export default "__VITE_ASSET__ec12d459__"